import React, {useEffect, useRef} from 'react'
import {Box, HStack, StackProps, useMultiStyleConfig} from '@chakra-ui/react'
import {CategoryMenu} from '_types'
import {Picture, MenuButton} from '_uiComponents'
import {getAnalyticsSecondLevel} from '_analytics/utils/analyticsUtils'
import {useViewport} from '_customHooks'

interface EditorialMenuProps {
    category: CategoryMenu
    menuStaticLibrary: string
    closeMenu: () => void
}

const EditorialMenu = ({category, menuStaticLibrary, closeMenu}: EditorialMenuProps): JSX.Element => {
    const styles = useMultiStyleConfig('SecondLevelMenu') as Record<string, StackProps>
    const mainMenu = category.analytics
    const {isMobile, isTablet, isDesktop} = useViewport()
    const analyticsTemplate = category.analyticsTemplate || ''
    const isTouchEnabled = useRef(false)

    // image trasformation for device it depend on the number of editorial items
    const imageTransformation = {
        default: ['700', '400', '750'],
        2: ['1275', '800', '750'],
        3: ['850', '400', '600'],
        5: ['600', '300', '750'],
    }

    const scaleImage = imageTransformation[category?.subcategories?.length || 0] || imageTransformation['default']

    useEffect(() => {
        if (window && window.matchMedia('(pointer: coarse)').matches) {
            // touchscreen
            isTouchEnabled.current = true
        }
    }, [])

    return (
        <>
            <HStack data-testid="editorial-menu" {...styles.editorial}>
                {category &&
                    category.subcategories &&
                    category.subcategories.map((subcategory, index) => (
                        <Box key={`${subcategory.cgid}-${index}`} {...styles.editorial} {...styles.editorialPictureWrapper}>
                            <Picture
                                objectFit="cover"
                                position={isMobile || isTablet ? 'absolute' : 'relative'}
                                zIndex={0}
                                alt={`${category.name} - ${subcategory.name}`}
                                imagexs={menuStaticLibrary + subcategory.image_mob + '?sw=' + scaleImage[2] + '&sfrm=jpg'}
                                imagelg={menuStaticLibrary + subcategory.image_tab + '?sw=' + scaleImage[1] + '&sfrm=jpg'}
                                imagexl={menuStaticLibrary + subcategory.image + '?sw=' + scaleImage[0] + '&sfrm=jpg'}
                            />
                            <Box {...styles.editorialLinkBox}>
                                <MenuButton
                                    href={subcategory.url || '#'}
                                    variant={'white'}
                                    closeMenu={isDesktop && isTouchEnabled.current ? closeMenu : undefined}
                                    analyticsEventData={getAnalyticsSecondLevel({
                                        category: subcategory,
                                        subcategory: null,
                                        mainMenu: mainMenu,
                                        analyticsTemplate: analyticsTemplate,
                                        position: (index + 1).toString(),
                                    })}
                                >
                                    {subcategory.name}
                                </MenuButton>
                            </Box>
                        </Box>
                    ))}
            </HStack>
            {category.url && category.show_all && (
                <Box {...styles.catalogShowAll}>
                    <MenuButton
                        href={category.url || '#'}
                        variant={'footer'}
                        closeMenu={isDesktop && isTouchEnabled.current ? closeMenu : undefined}
                        analyticsEventData={getAnalyticsSecondLevel({
                            category: category,
                            subcategory: null,
                            mainMenu: mainMenu,
                            analyticsTemplate: analyticsTemplate,
                            position: 'footer',
                        })}
                    >
                        {category.show_all.toUpperCase()}
                    </MenuButton>
                </Box>
            )}
        </>
    )
}

export default EditorialMenu
